import { getNumericParam, setParamIfDefined, setParamIfUndefined, toUrl } from "../utils.js";
export const parse = url => {
  const parsedUrl = toUrl(url);
  const width = getNumericParam(parsedUrl, "width");
  const height = getNumericParam(parsedUrl, "height");
  const format = parsedUrl.searchParams.get("format") || undefined;
  const quality = getNumericParam(parsedUrl, "quality") || undefined;
  return {
    width,
    height,
    format,
    base: parsedUrl.toString(),
    params: {
      quality
    },
    cdn: "keycdn"
  };
};
export const transform = _ref => {
  let {
    url: originalUrl,
    width,
    height,
    format
  } = _ref;
  const url = toUrl(originalUrl);
  setParamIfDefined(url, "width", width, true, true);
  setParamIfDefined(url, "height", height, true, true);
  setParamIfDefined(url, "format", format, true);
  setParamIfDefined(url, "quality", getNumericParam(url, "quality"), true);
  setParamIfUndefined(url, "enlarge", 0);
  return url;
};